// extracted by mini-css-extract-plugin
export default {"tableContainer":"styles_tableContainer__Z3qzz","searchInput":"styles_searchInput__wDSEz","tableHead":"styles_tableHead__p5eBQ","tableCell":"styles_tableCell__EfUQg"};